
export enum ImageSourceEnum {
    Undefined = 0,
    External = 1,
    Internal = 2
}
